<template>
  <div class="vuse-content-wrapper">
    <v-row class="fill-width">
      <v-col cols="10">
        <v-row class="mx-3 mt-4">
          <v-col class="mx-3" cols="3.5" sm="3.5">
            <v-text-field
                filled
                v-model="comment.name"
                label="Họ tên"
                placeholder="Nhập tên category"
                @input="debounceInput"
            ></v-text-field>
          </v-col>
          <v-col class="mx-3" cols="3.5" sm="3.5">
            <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    filled
                    v-model="dateStart"
                    label="Ngày bắt đầu"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="dateStart"
                  @input="menu1 = false"
                  @change="getItem"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col class="mx-3" cols="3.5" sm="3.5">
            <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    filled
                    v-model="dateEnd"
                    label="Ngày kết thúc"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="dateEnd"
                  @input="menu2 = false"
                  @change="getItem"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="2" align="right" class="mt-7">
        <v-btn color="primary" align="right" @click="addNew" v-if="hasPermissions('Create comment')">
          Thêm
        </v-btn>
      </v-col>
    </v-row>

    <v-container fluid>
      <v-row justify="center" align="center">
        <v-col cols="12">
          <v-data-table
              :headers="headers"
              :items="dataResult"
              :items-per-page="10"
              class="elevation-1"
          >
            <template v-slot:item.created_at="{ item }">
              <span>{{formatDate(item.created_at)}}</span>
            </template>
            <template v-slot:item.status="{ item }">
              <span v-if="item.status == 1" class="red--text font-weight-bold">CHỜ DUYỆT</span>
              <span v-else-if="item.status == 2" class="primary--text font-weight-bold">ĐÃ DUYỆT</span>
              <span v-else class="font-weight-bold">KHÔNG DUYỆT</span>
            </template>
            <template v-slot:item.type="{ item }">
              <span v-if="item.type == 1" class="font-weight-bold">USER</span>
              <span v-else-if="item.type == 2" class="warning--text font-weight-bold">ADMIN</span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)" v-if="hasPermissions('Update comment')">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item.id)" v-if="hasPermissions('Delete comment')"> mdi-delete </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>

import { GET_LIST_COMMENT,DELETE_COMMENT ,GET_DATA_SEARCH} from "@/store/modules/comments";

import { mapGetters } from "vuex";
import {debounce} from "debounce";
export default {
  data() {
    return {
      page: "Bình luận đánh giá",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true
        },
        {
          text: "Bình luận đánh giá",
          disabled: true,
        },
      ],
      comment: {
        name:"",
        limit: 10,
      },
      dateStart: "",
      dateEnd:"",
      menu1:false,
      menu2:false,
      active: [
        {id:1, name:'CHƯA KÍCH HOẠT'},
        {id:2, name:'ĐÃ BẢO HÀNH'},
      ],
      warranty_status: [
        {id:1, name:'CHỜ DUYỆT'},
        {id:2, name:'ĐÃ DUYỆT'},
      ],
      headers: [
        { text: "STT", value: "id" },
        {
          text: "Họ tên",
          align: "start",
          sortable: false,
          value: "name",
        },
        { text: 'Email', value: 'email' },
        { text: 'Sản phẩm', value: 'product_name' },
        { text: 'Bình luận', value: 'comment' },
        { text: 'Thời gian', value: 'created_at' },
        { text: 'Người dùng', value: 'type' },
        { text: 'Trạng thái', value: 'status' },
        { text: 'Actions', value: 'actions' },
      ],
      url: "",
    };
  },
  computed: {
    ...mapGetters({
      comments: "comments",
      dataResult: "dataSearchComment",
      production: "production",
    }),
  },
  watch: {
  },
  async created() {
    this.url = process.env.VUE_APP_API_URL;
    let param = {
      parent_id: this.$route.params.id
    }
    await this.$store.dispatch(GET_DATA_SEARCH, param);
    await this.$store.dispatch(GET_LIST_COMMENT, param);
  },
  methods: {
    debounceInput: debounce(function (e) {
      this.comment.name = e;
      let param = {
        name: this.comment.name,
        start_date:this.dateStart,
        end_date:this.dateEnd,
      };
      this.$store.dispatch(GET_DATA_SEARCH, param);
    }, 200),

    formatDate(date) {
      if (!date) return null;
      let newDate = new Date(date);
      const [year, month, day] = [
        newDate.getFullYear(),
        newDate.getMonth() + 1,
        newDate.getDate(),
      ];
      let day_format = day > 9 ? day : `0${day}`;
      let month_format = month > 9 ? month : `0${month}`;

      return `${day_format}/${month_format}/${year}`;
    },
    getItem() {
      let param = {
        name: this.comment.name,
        start_date:this.dateStart,
        end_date:this.dateEnd,
      };
      this.$store.dispatch(GET_DATA_SEARCH, param);
    },
    editItem(item) {
      this.$router.push(
          "/comment/detail_child_comment/" + item.id
      );
    },

    deleteItem(id) {
      let param = {
        parent_id: this.$route.params.id
      }
      confirm("Bạn có chắc muốn xóa?") &&
      this.$store.dispatch(`${DELETE_COMMENT}`, id).then((data) => {
        if (data && data.status === 1) {
          this.$store.dispatch(GET_DATA_SEARCH,param);
        }
      });
    },
    addNew() {
      this.parent_id = this.$route.params.id
      this.$router.push("/comment/add_comment/" +this.parent_id);
    },
  },
};
</script>
<style scoped lang="scss">
.content_category1 {
  background: #ffffff !important;
}
.width-input {
  max-width: 240px!important;
}
.img-brand {
  max-width: 100px;
  max-height: 100px;
  margin: auto;
  display: block;
}
</style>
